import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlus = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: .5,
		y: 5.5,
		width: 11,
		height: 1,
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("rect", {
		x: 5.5,
		y: 11.5,
		width: 11,
		height: 1,
		transform: "rotate(-90 5.5 11.5)",
		fill: "currentColor"
	})]
});
export default SvgPlus;
